import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6deb046c")

_pushScopeId("data-v-6deb046c")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { style: {"margin-top":"20px","margin-bottom":"10px"} }
const _hoisted_3 = { class: "healthlogo" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Get a 7 day free trial. ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cancel anytime, annual subscriptions also avaialble ")
const _hoisted_8 = { class: "btns" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Start Later")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_navbar, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, {
              color: "light",
              class: "onboarding-card"
            }, {
              default: _withId(() => [
                _createVNode(_component_ion_card_content, { class: "text-center" }, {
                  default: _withId(() => [
                    _createVNode("h1", _hoisted_2, " Join " + _toDisplayString(_ctx.client.name), 1),
                    _createVNode("div", _hoisted_3, [
                      _createVNode("img", {
                        style: {"margin-top":"20px","height":"100px"},
                        src: _ctx.client.logo
                      }, null, 8, ["src"])
                    ]),
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.manageSubscription())),
                        size: "block"
                      }, {
                        default: _withId(() => [
                          _createTextVNode("JOIN " + _toDisplayString(_ctx.client.name), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.isWeb)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SkipSubscribe())),
                            size: "small",
                            fill: "outline"
                          }, {
                            default: _withId(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})